import React, { useState } from 'react';
import axios from 'axios';
import Snackbar from '@mui/material/Snackbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import ReCAPTCHA from "react-google-recaptcha";
import { useAuth } from '../contexts/AuthContext.jsx';
import Login from './Login.jsx';
import { Button } from '@mui/material';
import './MobileLeftColumn.css';

function MobileLeftColumn() {
    const [email, setEmail] = useState('');
    const [isInputActive, setIsInputActive] = useState(false);
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState("");
    const [captchaValue, setCaptchaValue] = useState(null);
    const [loginOpen, setLoginOpen] = useState(false);
    const recaptchaRef = React.useRef(null);
    const siteKey = import.meta.env.VITE_RECAPTCHA_SITE_KEY;
    
    const { isAuthenticated, logout } = useAuth();

    const handleCaptchaResponseChange = (value) => {
        setCaptchaValue(value);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (siteKey && !captchaValue) {
            setSnackbarMessage("Please complete the CAPTCHA.");
            setOpenSnackbar(true);
            return;
        }        
        
        try {
            const apiUrl = `${import.meta.env.VITE_API_URL}/submit-email`;
            const response = await axios.post(apiUrl, { 
                email: email, 
                captchaValue: captchaValue 
            });
            
            setSnackbarMessage(response.data.message || "Email ontvangen!");
            setOpenSnackbar(true);
            recaptchaRef.current?.reset();
            setEmail('');
            setIsInputActive(false);
            
        } catch (error) {
            let errorMessage = "Er ging iets mis. Probeer het later nog eens.";

            if (error.response && error.response.data) {
                if (error.response.data.message) {
                    errorMessage = error.response.data.message;
                } else if (error.response.data.errors && error.response.data.errors.length > 0) {
                    const firstError = error.response.data.errors[0];
                    if (firstError.path === 'email') {
                        errorMessage = "Voer alstublieft een geldig emailadres in.";
                    } else {
                        errorMessage = firstError.msg;
                    }
                }
            }
            
            setSnackbarMessage(errorMessage);
            setOpenSnackbar(true);
            recaptchaRef.current?.reset();
    
            console.error('Error submitting email:', error.response ? error.response.data : error.message);
        }
    };

    return (
        <div className="mobile-left-column">
            <div className="mobile-logo-section">
                <img src="/MDA_Logo.svg" alt="MDA Logo" className="mobile-logo" />
                <p className="mobile-subheader">
                    Vanuit Maarten Delen Advies help ik op interimbasis scholen als tijdelijke directeur, 
                    locatiedirecteur of teamleider. Ik voer adviesopdrachten uit op het terrein van taakbeleid, 
                    kwaliteitszorg en interne veiligheid. Via de website deel ik mijn Ultra Korte Verhalen 
                    en de presentaties van mijn boekbesprekingen.
                </p>
            </div>

            <div className="mobile-newsletter-section">
                <h3>UKV's direct in je mailbox ontvangen?</h3>
                <p>Vul hier je emailadres in.</p>
                <input 
                    className="mobile-newsletter-input"
                    type="email"
                    placeholder="Email"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    onFocus={() => setIsInputActive(true)}
                    required
                />
                <button className="mobile-btn" onClick={handleSubmit}>Verstuur</button>

                {isInputActive && siteKey && (
                    <ReCAPTCHA
                        ref={recaptchaRef}
                        sitekey={siteKey}
                        onChange={handleCaptchaResponseChange}
                        style={{ marginTop: '16px' }}
                    />
                )}
            </div>

            <div className="mobile-auth-section">
                {isAuthenticated ? (
                    <Button 
                        variant="outlined" 
                        size="small" 
                        onClick={logout}
                        sx={{ width: '100%', mb: 1 }}
                    >
                        Logout
                    </Button>
                ) : (
                    <Button 
                        variant="outlined" 
                        size="small" 
                        onClick={() => setLoginOpen(true)}
                        sx={{ width: '100%', mb: 1 }}
                    >
                        Admin Login
                    </Button>
                )}
            </div>

            <div className="mobile-footer-info">
                <p>Maarten Delen Advies</p>
                <p>KvK: 83819541</p>
                <p>BTW: NL003876750B29</p>
                <p>Bank: NL 49 TRIO 0320 3203 16</p>
            </div>
        
            <Snackbar
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                open={openSnackbar}
                autoHideDuration={6000}
                onClose={() => setOpenSnackbar(false)}
                message={snackbarMessage}
                action={
                    <>
                        <IconButton size="small" aria-label="close" color="inherit" onClick={() => setOpenSnackbar(false)}>
                            <CloseIcon fontSize="small" />
                        </IconButton>
                    </>
                }
            />
            
            <Login 
                open={loginOpen} 
                onClose={() => setLoginOpen(false)}
            />
        </div>
    );
}

export default MobileLeftColumn;